export default __webpack_public_path__ + "img/shield.d152e439.svg";